import * as IkeModel from '@ikegps/core-shared';
import { addStyles, DefaultTheme } from '../../../components/theme';
import type { MithrilVNode } from '../../../mithril';
import { m } from '../../../mithril';
import { Services } from '../../../services';
import { CaptureThumbnail } from '../../capture.thumbnail/capture.thumbnail';
import { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const CSS = {
	capture: 'c-TrueSize__capture',
};

addStyles({
	[CSS.capture]: {
		padding: DefaultTheme.space(1),
	},
});

export const TrueSizeView: CollectionFieldView<IkeModel.CollectionModelFieldTrueSize> = {
	viewInline(field: IkeModel.CollectionModelFieldTrueSize): string {
		const captures = field.getCaptures();
		if (captures.length > 0) {
			return String(captures.length);
		}
		return '';
	},

	hasDetail(field: IkeModel.CollectionModelFieldTrueSize) {
		return field.getCaptures().length > 0;
	},

	viewDetail(field: IkeModel.CollectionModelFieldTrueSize): MithrilVNode {
		const captures: MithrilVNode[] = [];
		const className = CSS.capture;
		const imageCtx = { truesize: true, className, title: '' };
		const collection = field.collection;
		for (const capture of field.getCaptures()) {
			imageCtx.title = Services.DateTime.formatDateTime(capture.collectedAt.iso);
			const dom = CaptureThumbnail.view(collection, capture, imageCtx);
			captures.push(dom);
		}
		return m.fragment({}, captures);
	},

	viewEdit(field: IkeModel.CollectionModelFieldTrueSize, state: CollectionEditCtrl): MithrilVNode | string {
		return TrueSizeView.viewInline(field, state);
	},

	hasClear(field: IkeModel.CollectionModelFieldTrueSize): boolean {
		return false;
	},
};
